import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import CertWidgetSkeleton from './CertWidgetSkeleton'
import CertListPlaceholder from './subcomponents/CertList/CertListPlaceholder'

const CertWidgetPlaceholder = () => {
  return (
    <CertWidgetSkeleton
      headerSection={<LoadingBox width="80px">&nbsp;</LoadingBox>}
      contentSection={<CertListPlaceholder />}
    />
  )
}

export default CertWidgetPlaceholder
